export default __webpack_public_path__ + "static/media/akash.57c7440c.jpg";